import bg from "./assets/bg-reviews.svg"
import avatar1 from "assets/images/review-avatar-1.png"
import avatar2 from "assets/images/review-avatar-2.png"
import avatar3 from "assets/images/review-avatar-3.png"
import avatar4 from "assets/images/review-avatar-4.png"
import { FormattedMessage } from "react-intl"
import { ReactComponent as ReviewsBorder } from "assets/images/reviews-border.svg"
import starsIcon from "./assets/5-stars.png"

export function Reviews() {
  return (
    <div
      className="bg-no-repeat bg-[length:100%_100%] bg-center pt-12 pb-[64px] text-white px-8"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <h2 className="font-quirk text-[32px] leading-[40px] tracking-[0.5px] text-center mb-6">
        Start your dating adventures
      </h2>
      <div>
        {Array.from(Array(4).keys()).map((i) => (
          <div
            className="relative p-5 mb-3 tracking-[0.5px]"
            key={`review-${i}`}
          >
            <ReviewsBorder className="absolute w-full h-full text-violet-190 left-0 top-0" />
            <div className="flex items-start z-10 relative w-full">
              <img
                src={[avatar1, avatar2, avatar3, avatar4][i]}
                className="w-[54px] h-[54px] mr-4"
              />
              <div className="text-sm">
                <img src={starsIcon} className="w-[60px] mb-1" />
                <div className="font-sans-bold">
                  <FormattedMessage id={`paygate.reviews.${i + 1}.title`} />
                </div>
                <div>
                  <FormattedMessage id={`paygate.reviews.${i + 1}.text`} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
